"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPropertyAmenityDto = instanceOfPropertyAmenityDto;
exports.PropertyAmenityDtoFromJSON = PropertyAmenityDtoFromJSON;
exports.PropertyAmenityDtoFromJSONTyped = PropertyAmenityDtoFromJSONTyped;
exports.PropertyAmenityDtoToJSON = PropertyAmenityDtoToJSON;
exports.PropertyAmenityDtoToJSONTyped = PropertyAmenityDtoToJSONTyped;
/**
 * Check if a given object implements the PropertyAmenityDto interface.
 */
function instanceOfPropertyAmenityDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function PropertyAmenityDtoFromJSON(json) {
    return PropertyAmenityDtoFromJSONTyped(json, false);
}
function PropertyAmenityDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'icon': json['icon'] == null ? undefined : json['icon'],
    };
}
function PropertyAmenityDtoToJSON(json) {
    return PropertyAmenityDtoToJSONTyped(json, false);
}
function PropertyAmenityDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'icon': value['icon'],
    };
}
